import { MUIDataTableColumn, MUIDataTableMeta } from 'mui-datatables';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { formatPhoneNumber } from 'src/utils';
import { SYSTEM_USER_KEY } from './helpers';
import { PATHS } from 'src/appConfig/paths';

export const allColumns = (): MUIDataTableColumn[] => [
  {
    name: SYSTEM_USER_KEY.NAME,
    label: 'Name',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (
        value: any,
        meta: MUIDataTableMeta | (Omit<MUIDataTableMeta, 'tableData'> & { tableData: any[] })
      ) => {
        const rowData = meta.tableData[meta.rowIndex] as any;
        return (
          <Link
            to={{
              pathname: `${PATHS.admin}${PATHS.userListing}/${rowData.id}`,
            }}
          >
            <Typography sx={{ fontSize: 14, color: '#4684E7' }} variant="body2">
              {value ?? ''}
            </Typography>
          </Link>
        );
      },
    },
  },
  {
    name: SYSTEM_USER_KEY.EMAIL,
    label: 'Email',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: any, meta: MUIDataTableMeta) => {
        return <div className={'body__medium'}>{value ?? ''}</div>;
      },
    },
  },

  {
    name: SYSTEM_USER_KEY.PHONE_NUMBER,
    label: 'Phone Number',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: any, meta: MUIDataTableMeta) => {
        return <div className={'body__medium'}>{formatPhoneNumber(value) ?? '--'}</div>;
      },
    },
  },
];
